module.exports = __webpack_public_path__ + "img/cover-minigame-bg-mobile.8e9b60e5.jpg";